// AIDEV-NOTE: tenký šev kolem window.location.assign, aby šel v testech zamockovat —
// jsdom location.assign neimplementuje. Tvrdý přechod (celé načtení stránky) je nouzová
// cesta, když se SPA navigace necommitne. [TD-467]
export const hardNavigate = (path: string): void => {
  window.location.assign(path);
};
